import { type BillingCustomer, type Plan } from '../../models/Plan'
import { isAggregateBilling, isEmailInvoiced } from './billingFacts'
import { useBillingPlan } from './useBillingPlan'
import { useCanBuySeats } from './useCanBuySeats'

export const allowsSeatPurchase = (customer?: BillingCustomer, plan?: Plan): boolean => {
  if (!customer?.subscription || !plan || plan.type === 'free') {
    return false
  }
  return isAggregateBilling(customer) || customer.hasPaymentMethod || isEmailInvoiced(customer)
}

export const useSeatPurchaseGate = (): boolean => {
  const hasPermission = useCanBuySeats()
  const { customer, plan } = useBillingPlan(!hasPermission)

  return hasPermission && allowsSeatPurchase(customer, plan)
}
